import { createSelector } from '@reduxjs/toolkit';
import { selectBuildingClassType, selectOfficeTypes } from 'shared/selectors/jsonQuery';
import { EBuildingClassType } from '../../../../packages/api-models/common/json_query';
import { getBuildingClassTypeFields } from '../../../../packages/JsonQuery/utils/getBuildingClassTypeFields';

const LABELS: Partial<Record<EBuildingClassType, string>> = {
  [EBuildingClassType.A]: 'A',
  [EBuildingClassType.B]: 'B',
  [EBuildingClassType.C]: 'C',
  [EBuildingClassType.D]: 'D',
};

export const selectBuildingClassTypeFilter = createSelector(
  [selectBuildingClassType, selectOfficeTypes],
  (value, officeTypes) => ({
    label: 'Класс',
    options: getBuildingClassTypeFields(officeTypes).map(field => ({ label: LABELS[field] ?? '', value: field })),
    value: value && value.length > 0 ? value : [null],
  }),
);
